import { z } from 'zod';
import { nullStr, nullObj } from 'schemas/nullable';

const sourceZoneRefSchema = z.object({
  code: z.string().default(''),
  color: z.string().default(''),
});

const sourceLocationRefSchema = z.object({
  _id: z.string().default(''),
  code: z.string().default(''),
  zoneId: sourceZoneRefSchema.nullable().default(null),
});

const quantitySchema = z.object({
  available: z.number().default(0),
  allocated: z.number().default(0),
  transfer: z.number().default(0),
});

const palletRefSchema = nullObj({
  _id: z.string(),
  palletNumber: z.string(),
});

export const transferSourceInventoryRowSchema = z.object({
  inventoryId: z.string().default(''),
  productId: z.string().default(''),
  sourceLocationId: z.string().default(''),
  sourceLocation: sourceLocationRefSchema.nullable().default(null),
  isPickingLocation: z.boolean().default(false),
  lotNumber: nullStr(),
  cartonAlias: nullStr(),
  quantity: quantitySchema.default({
    available: 0,
    allocated: 0,
    transfer: 0,
  }),
  pickableQuantity: z.number().default(0),
  pallet: palletRefSchema,
});

export const transferSourceInventoryListResponseSchema = z.object({
  data: z.array(transferSourceInventoryRowSchema),
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number(),
});

export type TransferSourceInventoryRow = z.infer<typeof transferSourceInventoryRowSchema>;
export type TransferSourceInventoryListResponse = z.infer<
  typeof transferSourceInventoryListResponseSchema
>;
